import * as React from "react";
const SvgCrystal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 66, cy: 67, fill: "none", rx: 57, ry: 41, style: {
  fill: "red",
  fillOpacity: 0,
  strokeWidth: 3,
  stroke: "red",
  strokeDasharray: "none"
}, transform: "matrix(1 0 0 1.19512 -2 -16.073)" }));
export default SvgCrystal;
